import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import axios from "axios";
import { useSWRConfig } from "swr";

import { useToastPromise } from "@/hooks/useToast";
import { colorSchemes } from "@/utils/colorSchemes";
import { ApplicationListStatuses } from "@/types/accreditation";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  accreditationId: number;
  eventId: number;
  mutateList: boolean;
};

const WithdrawAccreditationModal = ({
  isOpen,
  onClose,
  accreditationId,
  eventId,
  mutateList = false,
}: Props): React.ReactElement => {
  const { t } = useTranslation("common");
  const toast = useToastPromise();
  const { mutate } = useSWRConfig();
  const withdrawButtonColors = colorSchemes("red");

  const handleWithdraw = () => {
    toast.promise(
      axios.post(`/accreditation/user/${accreditationId}/withdraw`).then(() => {
        mutate(`/accreditation/event/${eventId}`);
        mutate("/accreditation/user");

        if (mutateList) {
          mutate(
            `/accreditation/list/${eventId}/${ApplicationListStatuses.PENDING}`
          );
          mutate(
            `/accreditation/list/${eventId}/${ApplicationListStatuses.GRANTED}`
          );
          mutate(
            `/accreditation/list/${eventId}/${ApplicationListStatuses.OTHER}`
          );
        }

        onClose();
      }),
      {
        success: t("events.withdrawSuccess"),
      }
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size="xl"
      preserveScrollBarGap
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("events.withdrawTitle")}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text>{t("events.withdrawDescription")}</Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            {t("cancel")}
          </Button>
          <Button onClick={handleWithdraw} {...withdrawButtonColors}>
            {t("events.withdrawApplication")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default WithdrawAccreditationModal;
